export default __webpack_public_path__ + "static/media/title_pc@2x.2153abf0.png";